export const JOB_ORDER_INCLUDES =
  'recruiter,createdBy,additionalRecruiters,status,hiringAuthorities';
